"use client";
import {JSX, ReactNode} from "react";

import Link from "next/link";

import classNames from "classnames";

import {PolymorphicButton} from "./types";

import "./styles/button-simple.scss";

type ButtonSimpleVariant = "primary" | "secondary" | "secondary-outline";
type ButtonSimpleSize = "sm" | "md";

type ButtonSimpleProps = {
    variant?: ButtonSimpleVariant;
    size?: ButtonSimpleSize;
    children: ReactNode;
    prefetch?: boolean;
};

type ButtonSimplePolymorphic = PolymorphicButton<ButtonSimpleProps>;

export function ButtonSimple(props: ButtonSimplePolymorphic): JSX.Element {
    const {variant = "primary", size, className: classNameProp, ...rest} = props;

    const className = classNames("button-simple", variant, classNameProp, size && `button-simple--${size}`);
    if (rest.as === "link") {
        const {as: _as, children, target, prefetch = false, ...linkProps} = rest;

        return (
            <Link className={className} prefetch={prefetch} {...(target && {target})} {...linkProps}>
                {children}
            </Link>
        );
    }

    const {type = "button", children, ...buttonProps} = rest;

    return (
        <button type={type} className={className} {...buttonProps}>
            {children}
        </button>
    );
}
